// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   LOGOUT PAGE COMPONENT STYLES
   ============================================ */

.logout-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 50vh;
	padding: 2rem;
}

.logout-message {
	text-align: center;
	color: #495057;
	margin-bottom: 2rem;
}

.logout-message h2 {
	color: #27405f;
	margin-bottom: 1rem;
}

/* ============================================
   PRIMENG BUTTON OVERRIDES
   ============================================ */
:host ::ng-deep .p-button {
	background: #27405f !important;
	border-color: #27405f !important;
	font-weight: 600 !important;
}

:host ::ng-deep .p-button:enabled:hover {
	background: #1d3049 !important;
	border-color: #1d3049 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/logout-page/logout-page.component.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;;iDAEiD;AACjD;CACC,8BAA8B;CAC9B,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC","sourcesContent":["/* ============================================\n   LOGOUT PAGE COMPONENT STYLES\n   ============================================ */\n\n.logout-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 50vh;\n\tpadding: 2rem;\n}\n\n.logout-message {\n\ttext-align: center;\n\tcolor: #495057;\n\tmargin-bottom: 2rem;\n}\n\n.logout-message h2 {\n\tcolor: #27405f;\n\tmargin-bottom: 1rem;\n}\n\n/* ============================================\n   PRIMENG BUTTON OVERRIDES\n   ============================================ */\n:host ::ng-deep .p-button {\n\tbackground: #27405f !important;\n\tborder-color: #27405f !important;\n\tfont-weight: 600 !important;\n}\n\n:host ::ng-deep .p-button:enabled:hover {\n\tbackground: #1d3049 !important;\n\tborder-color: #1d3049 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
